import { NavLink } from 'react-router-dom';

const TABS = [
  ['/comms/inbox', 'Inbox', 'inbox'], ['/comms/bulk', 'Bulk Campaigns', 'bulk'], ['/comms/requests', 'Information Requests', 'requests'],
  ['/comms/templates', 'Templates', 'templates'], ['/comms/responses', 'Responses', 'responses'], ['/comms/reports', 'Campaign Reports', 'reports'],
];

export const CommsTabs = () => (
  <nav className="flex items-center gap-1 px-3 border-b border-border overflow-x-auto bg-card/40" aria-label="Communications sections" data-testid="comms-section-tabs">
    {TABS.map(([to, label, key]) => (
      <NavLink key={key} to={to} data-testid={`comms-section-${key}`}
        className={({ isActive }) => `px-3 py-2 text-sm whitespace-nowrap border-b-2 transition-colors ${isActive ? 'border-primary text-foreground font-medium' : 'border-transparent text-muted-foreground hover:text-foreground'}`}>
        {label}
      </NavLink>
    ))}
  </nav>
);

export const STATUS_LABEL = {
  awaiting: 'Awaiting response', awaiting_review: 'Awaiting review', completed: 'Completed', pending_not_obtained: 'Pending – not obtained',
  follow_up: 'Follow-up required', cancelled: 'Cancelled', paused: 'Paused', excluded: 'Excluded', 'n/a': '—',
  queued: 'Queued', queued_tomorrow: 'Queued for tomorrow', sent: 'Sent', delivered: 'Delivered', failed: 'Delivery failed', no_email: 'No email – manual follow-up',
  retry: 'Retrying (rate limited)', reminder_due: 'Reminder queued',
};
